// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2mwaY","consentsList":"PatientConsents_consentsList__chFYY","consentsListEmpty":"PatientConsents_consentsListEmpty__Sa50V"};